<template>
  <div class="admin-layout">
    <a-layout :style="{ minHeight: '100vh' }">
      <a-layout-sider v-model="collapsed" :trigger="null" collapsible :collapsedWidth="48">
        <TreeMenu :collapsed="collapsed" />
      </a-layout-sider>
      <a-layout>
        <div class="header-top">
          <a-dropdown>
            <a class="ant-dropdown-link" @click="(e) => e.preventDefault()">
              <a-icon style="font-size: 18px" type="user" />
              <span> {{ userInfo.userName }} </span>
              <a-icon type="down" />
            </a>
            <a-menu slot="overlay" @click="handleMenuClick">
              <a-menu-item key="account_setting">
                <a href="javascript:;"><a-icon type="setting" /> 账号设置</a>
              </a-menu-item>
              <a-menu-item key="edit_pwd">
                <a href="javascript:;"><a-icon type="lock" /> 修改密码</a>
              </a-menu-item>

              <!-- <a-menu-item key="forgot_pwd">
                <a href="javascript:;"><a-icon type="lock" /> 忘记密码</a>
              </a-menu-item> -->

              <a-menu-item key="login_out">
                <a href="javascript:;"><a-icon type="poweroff" /> 安全退出</a>
              </a-menu-item>
            </a-menu>
          </a-dropdown>

          <div>
            <a-icon
              style="font-size: 16px"
              :type="collapsed ? 'menu-unfold' : 'menu-fold'"
              @click="onCollapsedChange"
            />
          </div>
        </div>
        <!-- 面包屑 -->
        <a-breadcrumb class="breadcrumb-container" v-if="breadcrumbs">
          <!--          <a-breadcrumb-item>-->
          <!--            <rouoter-link to="'/dashboard'">首页</rouoter-link>-->
          <!--          </a-breadcrumb-item>-->
          <a-breadcrumb-item
            v-for="(bread, index) in breadcrumbs"
            :class="bread.link ? 'can-click' : ''"
            @click.native="toLink(bread)"
            :key="index"
          >
            {{ bread.name }}
          </a-breadcrumb-item>
        </a-breadcrumb>
        <keep-alive>
          <router-view v-if="$route.meta.alive" />
        </keep-alive>
        <router-view v-if="!Boolean($route.meta.alive)" />
      </a-layout>
      <a-back-top />
    </a-layout>
    <div class="loading-wrap" v-if="loading">
      <div class="loading-item">
        <a-spin size="large"></a-spin>
        <div class="spin-content">{{ loadingText }}</div>
      </div>
    </div>
    <a-modal
      title="修改密码"
      :visible="pwdVisible"
      @ok="handleEditPwd"
      @cancel="pwdVisible = false"
    >
      <a-form-model
        ref="pwdForm"
        :label-col="labelCol"
        :wrapper-col="wrapperCol"
        :model="pwdForm"
        :rules="pwdRules"
      >
        <a-form-model-item label="原密码" prop="oldPassword">
          <a-input v-model="pwdForm.oldPassword" placeholder="请输入原密码" />
        </a-form-model-item>
        <a-form-model-item label="新密码" prop="newPassword">
          <a-input v-model="pwdForm.newPassword" placeholder="请输入新密码" />
        </a-form-model-item>

        <a-form-model-item label="确认新密码" prop="confimPassword">
          <a-input v-model="pwdForm.confimPassword" placeholder="请再次输入新密码" />
        </a-form-model-item>
      </a-form-model>
    </a-modal>
    <a-modal
      title="修改信息"
      :visible="userVisible"
      @ok="handleEditUser"
      @cancel="userVisible = false"
    >
      <a-form-model
        ref="userForm"
        :label-col="labelCol"
        :wrapper-col="wrapperCol"
        :model="userForm"
        :rules="userRules"
      >
        <a-form-model-item label="用户名" prop="userName">
          <a-input v-model="userForm.userName" placeholder="请输入用户名" />
        </a-form-model-item>
        <a-form-model-item label="手机号" prop="phone">
          <a-input v-model="userForm.phone" placeholder="请输入手机号" />
        </a-form-model-item>
        <a-form-model-item label="邮箱" prop="mail">
          <a-input v-model="userForm.mail" placeholder="请输入邮箱" />
        </a-form-model-item>
      </a-form-model>
    </a-modal>

    <a-modal
      title="忘记密码"
      :visible="forgotPwdVisible"
      @ok="handleForgotPwd"
      @cancel="forgotPwdVisible = false"
    >
      <a-form-model
        ref="forgotForm"
        :label-col="labelCol"
        :wrapper-col="wrapperCol"
        :model="forgotForm"
        :rules="forgotRules"
      >
        <a-form-model-item label="账号" prop="loginAccount">
          <a-input v-model="forgotForm.loginAccount" placeholder="请输入手机号或邮箱"> </a-input>
        </a-form-model-item>
        <a-form-model-item label="验证码" prop="verifyCode">
          <a-input
            v-model="forgotForm.verifyCode"
            :placeholder="verificationPlaceholder"
            prop="verifyCode"
          >
            <a-button
              @click="getVerifyCode"
              type="link"
              slot="suffix"
              :loading="codeLoading"
              :disabled="verificationDisabled"
              ><a-divider type="vertical" /> <span>获取验证码</span>
            </a-button>
          </a-input>
        </a-form-model-item>
        <a-form-model-item label="新密码" prop="newPassword">
          <a-input v-model="forgotForm.newPassword" type="password" placeholder="请输入密码">
          </a-input>
        </a-form-model-item>
        <a-form-model-item label="确认新密码" prop="confimPassword">
          <a-input v-model="forgotForm.confimPassword" type="password" placeholder="请再次输入密码">
          </a-input>
        </a-form-model-item>
      </a-form-model>
    </a-modal>
  </div>
</template>
<script>
import TreeMenu from '@/components/TreeMenu'
import { getBreadcrumbList, removeToken } from '../utils/index'
import { mapState, mapMutations } from 'vuex'
import {
  changePasswordApi,
  changeBaseApi,
  getVerifyCodeApi,
  forgotPasswordApi
} from '@/api/System/User'

const phoneReg = /^(13[0-9]|14[01456879]|15[0-35-9]|16[2567]|17[0-8]|18[0-9]|19[0-35-9])\d{8}$/
const emailReg = /^\w+([-+.]\w+)*@\w+([-.]\w+)*\.\w+([-.]\w+)*$/
export default {
  data() {
    let validatePhone = (rule, value, callback) => {
      if (value === '') {
        callback(new Error('请输入手机号'))
      } else {
        if (phoneReg.test(value)) {
          callback()
        } else {
          callback(new Error('请输入正确的手机号'))
        }
      }
    }
    let validateMail = (rule, value, callback) => {
      if (value === '') {
        callback(new Error('请输入邮箱'))
      } else {
        if (emailReg.test(value)) {
          callback()
        } else {
          callback(new Error('请输入正确的邮箱格式'))
        }
      }
    }

    let validatePass = (rule, value, callback) => {
      if (value === '') {
        callback(new Error('请输入密码'))
      } else {
        if (this.pwdForm.confirmPassword !== '') {
          this.$refs.pwdForm.validateField('confimPassword')
        }
        callback()
      }
    }

    let validateComfirmPass = (rule, value, callback) => {
      if (value === '') {
        callback(new Error('请再次输入密码'))
      } else if (value != this.pwdForm.newPassword) {
        callback(new Error('两次密码不相同'))
      } else {
        callback()
      }
    }

    let validateLoginAccount = (rule, value, callback) => {
      if (value === '') {
        callback(new Error('请输入手机号或邮箱'))
      } else {
        if (phoneReg.test(value) || emailReg.test(value)) {
          callback()
        } else {
          callback(new Error('请输入正确的手机号或邮箱格式'))
        }
      }
    }

    let validateForgotPass = (rule, value, callback) => {
      if (value === '') {
        callback(new Error('请输入密码'))
      } else {
        if (this.forgotForm.confirmPassword !== '') {
          this.$refs.forgotForm.validateField('confimPassword')
        }
        callback()
      }
    }

    let validateForgotComfirmPass = (rule, value, callback) => {
      if (value === '') {
        callback(new Error('请再次输入密码'))
      } else if (value != this.forgotForm.newPassword) {
        callback(new Error('两次密码不相同'))
      } else {
        callback()
      }
    }

    return {
      labelCol: { span: 5 },
      wrapperCol: { span: 19 },
      collapsed: false,
      breadcrumbs: [],
      pwdVisible: false,
      userVisible: false,
      forgotPwdVisible: false,
      codeLoading: false,
      count: null,
      verificationDisabled: false,
      verificationPlaceholder: '请输入验证码',
      pwdForm: {
        newPassword: '',
        oldPassword: '',
        confirmPassword: ''
      },
      forgotForm: {
        loginAccount: '',
        verifyCode: '',
        newPassword: '',
        confirmPassword: ''
      },
      pwdRules: {
        oldPassword: [{ required: true, message: '请输入原密码', trigger: 'change' }],
        newPassword: [{ required: true, validator: validatePass, trigger: 'change' }],
        confimPassword: [{ required: true, validator: validateComfirmPass, trigger: 'change' }]
      },
      forgotRules: {
        loginAccount: [{ required: true, validator: validateLoginAccount, trigger: 'change' }],
        verifyCode: [{ required: true, message: '请输入验证码', trigger: 'change' }],
        newPassword: [{ required: true, validator: validateForgotPass, trigger: 'change' }],
        confimPassword: [
          { required: true, validator: validateForgotComfirmPass, trigger: 'change' }
        ]
      },
      userForm: {
        userId: '',
        userName: '',
        phone: '',
        mail: ''
      },

      userRules: {
        userName: [{ required: true, message: '请输入用户名', trigger: 'change' }],
        phone: [
          { required: true, message: '请输入手机号', trigger: 'change' },
          { validator: validatePhone, trigger: ['change', 'blur'] }
        ],
        mail: [
          { required: true, message: '请输入邮箱', trigger: 'change' },
          { validator: validateMail, trigger: ['change', 'blur'] }
        ]
      }
    }
  },
  components: {
    TreeMenu
  },
  methods: {
    ...mapMutations(['SET_LOADING', 'SET_INSTALL']),
    initPwd() {
      this.pwdForm.newPassword = ''
      this.pwdForm.oldPassword = ''
      this.pwdForm.confirmPassword = ''
    },
    initForgotPwd() {
      this.forgotForm.loginAccount = ''
      this.forgotForm.verifyCode = ''
      this.forgotForm.newPassword = ''
      this.forgotForm.confirmPassword = ''
    },
    onCollapsedChange() {
      this.collapsed = !this.collapsed
      this.$store.commit('Set_Individualization_Setting', {
        key: 'collapsed',
        value: this.collapsed
      })
    },
    handleMenuClick(e) {
      let { key } = e
      const self = this
      if ('login_out' === key) {
        this.$confirm({
          content: '确定要退出吗',
          onOk() {
            removeToken()
            self.SET_INSTALL(false)
            self.$router.push({ name: 'login' })
          },
          cancelText: '取消',
          onCancel() {
            self.$destroyAll()
          }
        })
      }
      if ('edit_pwd' === key) {
        this.pwdVisible = true
      }
      if ('account_setting' === key) {
        this.userVisible = true
        this.userForm.userName = this.userInfo.userName
        this.userForm.phone = this.userInfo.phone
        this.userForm.mail = this.userInfo.mail
        this.userForm.userId = this.userInfo.userId
      }

      if ('forgot_pwd' === key) {
        this.initPwd()
        this.forgotPwdVisible = true
      }
    },
    handleForgotPwd() {
      this.$refs.forgotForm.validate(async (valid) => {
        if (valid) {
          let res = await forgotPasswordApi({
            userId: this.userInfo.userId,
            verifyCode: this.forgotForm.verifyCode,
            password: this.forgotForm.newPassword
          })
          let { code, msg } = res
          if (code == '200') {
            this.$message.success('密码重置成功')
            this.forgotPwdVisible = false
            removeToken()
            this.$router.push({ name: 'login' })
          } else {
            this.$message.error(msg)
          }
        } else {
          return false
        }
      })
    },
    handleEditPwd() {
      this.$refs.pwdForm.validate(async (valid) => {
        if (valid) {
          let res = await changePasswordApi(this.pwdForm)
          let { code, msg } = res
          if (code == '200') {
            this.$message.success('密码修改成功')
            this.pwdVisible = false
            removeToken()
            this.$router.push({ name: 'login' })
          } else {
            this.$message.error(msg)
          }
        } else {
          return false
        }
      })
    },
    handleEditUser() {
      this.$refs.userForm.validate(async (valid) => {
        if (valid) {
          let res = await changeBaseApi(this.userForm)
          let { code, msg } = res
          if (code == '200') {
            this.$message.success('修改用户信息成功')
            this.userVisible = false
            removeToken()
            this.$router.push({ name: 'login' })
          } else {
            this.$message.error(msg)
          }
        } else {
          return false
        }
      })
    },

    //获取验证码
    async getVerifyCode() {
      this.codeLoading = true
      this.verificationDisabled = true
      if (
        phoneReg.test(this.forgotForm.loginAccount) ||
        emailReg.test(this.forgotForm.loginAccount)
      ) {
        let type = ''
        if (phoneReg.test(this.forgotForm.loginAccount)) {
          type = 'sms'
        } else if (emailReg.test(this.forgotForm.loginAccount)) {
          type = 'mail'
        } else {
          type = ''
        }
        let res = await getVerifyCodeApi({ loginAccount: this.forgotForm.loginAccount, type })
        let { code, msg } = res
        if (code == 200) {
          this.getPhoneCode()
        } else {
          this.verificationDisabled = false
          this.$message.error(msg)
        }
      } else {
        this.verificationDisabled = false
        this.$message.error('请填写正确的手机号或邮箱')
      }
      this.codeLoading = false
    },
    getPhoneCode() {
      let TIME_COUNT = 60
      if (!this.timer) {
        this.count = TIME_COUNT
        this.timer = setInterval(() => {
          if (this.count > 0 && this.count <= TIME_COUNT) {
            this.count--
            this.verificationPlaceholder = this.count + 's后重新获取验证码'
          } else {
            clearInterval(this.timer)
            this.timer = null
            this.verificationPlaceholder = '请输入验证码'
            this.verificationDisabled = false
          }
        }, 1000)
      }
    },
    toLink(item) {
      if (item.link) {
        this.$router.push(item.link)
      }
    }
  },

  computed: {
    ...mapState({
      loading: (state) => state.loading,
      loadingText: (state) => state.loadingText,
      userInfo: (state) => state.userInfo
    })
  },

  watch: {
    $route: {
      immediate: true,
      handler() {
        // this.breadcrumbs = getBreadcrumbList(this.$route.name)
        let temp = {
          Dashboard: [{ name: '首页' }],
          'online-search': [{ name: '在线搜索' }],
          site_type: [{ name: '采集配置' }, { name: '站点分类' }],
          site_manage: [{ name: '监控中心' }, { name: '站点管理' }],
          site_create_form: [
            { name: '采集配置' },
            { name: '站点管理', link: '/site_manage' },
            { name: '站点表格' }
          ],
          site_info: [
            { name: '采集配置' },
            { name: '站点管理', link: '/site_manage' },
            { name: '站点详情' }
          ],
          site_approval: [{ name: '采集配置' }, { name: '站点审批' }],
          site_approval_list: [
            { name: '采集配置' },
            { name: '站点申请', link: 'site_create_type' },
            { name: '申请列表' }
          ],
          template: [{ name: '采集配置' }, { name: '模版配置' }],
          site_create_type: [{ name: '采集配置' }, { name: '站点申请' }],
          data_manage: [{ name: '数据中心' }, { name: '数据导出' }],
          data_count: [{ name: '数据中心' }, { name: '数据统计' }],
          seed_poll: [{ name: '智能发现' }, { name: '种子账号管理' }],
          site_find: [{ name: '智能发现' }, { name: '站点发现' }],
          dispatch_task_manage: [{ name: '监控中心' }, { name: '任务列表' }],
          dispatch_task_info: [
            { name: '调度中心' },
            { name: '任务列表', link: '/dispatch_task_manage' },
            { name: '任务详情' }
          ],
          subscribe_site: [{ name: '订阅中心' }, { name: '站点订阅' }],
          monitor_abnormal: [{ name: '监控中心' }, { name: '异常监控' }],
          monitor_gatherer: [{ name: '监控中心' }, { name: '爬取异常监控' }],
          monitor_parsingExceptions: [{ name: '监控中心' }, { name: '解析异常监控' }],
          monitor_dailyRecord: [{ name: '监控中心' }, { name: '异常告警日志' }],
          monitor_monitoring: [{ name: '监控中心' }, { name: '异常监控配置' }],
          monitor_gathererInfo: [
            { name: '监控中心' },
            { name: '爬取异常监控', link: '/monitor_gatherer' },
            { name: '爬取异常监控详情' }
          ],
          monitor_parsingExceptionsInfo: [
            { name: '监控中心' },
            { name: '解析异常监控', link: '/monitor_parsingExceptions' },
            { name: '解析异常监控详情' }
          ],
          ip_pool: [{ name: '系统配置' }, { name: 'IP池' }],
          mq_config: [{ name: '系统配置' }, { name: 'MQ配置' }],
          menu: [{ name: '系统配置' }, { name: '菜单管理' }],
          user: [{ name: '系统配置' }, { name: '用户管理' }],
          dispatch_account_poll: [{ name: '系统配置' }, { name: '账号池管理' }],
          system_service_node: [{ name: '系统配置' }, { name: '节点管理' }],
          system_basic_image: [{ name: '系统配置' }, { name: '基础镜像管理' }],
          system_data_base: [{ name: '系统配置' }, { name: '数据库管理' }],
          tag: [{ name: '系统配置' }, { name: '标签管理' }],
          Sensitive: [{ name: '系统配置' }, { name: '敏感词管理' }],
          role: [{ name: '系统配置' }, { name: '角色管理' }],
          paging: [{ name: '系统配置' }, { name: '翻页模板管理' }],
          wiki_type: [{ name: '专题爬取' }, { name: '维基分类' }],
          collectlist: [
            { name: '专题爬取' },
            { name: '维基分类', link: '/wiki_type' },
            { name: '详情' }
          ],
          collect_info: [
            { name: '专题爬取' },
            { name: '维基分类', link: '/wiki_type' },
            { name: '采集详情' }
          ],
          wiki_pedia: [{ name: '专题爬取' }, { name: '维基百科采集' }]
        }
        this.breadcrumbs = temp[this.$route.name]
      }
    }
  },

  mounted() {
    const _collapsed = this.$store.getters.individualizationSettings('collapsed')
    this.collapsed = Boolean(_collapsed)
  }
}
</script>
<style lang="less" scoped>
.admin-layout {
  .loading-wrap {
    position: fixed;
    height: 100%;
    width: 100%;
    background: rgba(0, 0, 0, 0.7);
    left: 0;
    top: 0;
    z-index: 999;
    .loading-item {
      position: absolute;
      left: 50%;
      top: 50%;
      transform: translate(-50%, -50%);
      .spin-content {
        margin-top: 20px;
        color: #fff;
        text-align: center;
      }
    }
  }
}
.header-top {
  width: 100%;
  height: 48px;
  line-height: 48px;
  display: flex;
  z-index: 20;
  background: white;
  flex-direction: row-reverse;
  justify-content: space-between;
  box-shadow: 0 1px 4px rgba(0, 21, 41, 0.08);
  padding: 0 20px 0 30px;
}
.breadcrumb-container {
  background-color: white;
  padding: 10px 16px;
}
.can-click {
  cursor: pointer;
}
.can-click:hover {
  color: #1da1f2;
}
</style>
<style>
.ant-back-top {
  right: 10px !important;
}
</style>
